module.exports = __webpack_public_path__ + "img/20200801_130506.8acc68a3.jpg";